import React, { useState } from 'react';
import {
  HStack,
  VStack,
  Input,
  Button,
  Avatar,
  FormControl,
  useColorModeValue,
  Box
} from '@chakra-ui/react';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import CommentImageUpload from '../CommentImageUpload';

const ReplyInput = ({ user, onSubmit, siteId, commentId }) => {
  const [replyText, setReplyText] = useState('');
  const [replyPhotoUrl, setReplyPhotoUrl] = useState('');

  const borderColor = useColorModeValue('ancient.stone', 'whiteAlpha.300');

  const handleSubmit = async () => {
    const success = await onSubmit(replyText, replyPhotoUrl, commentId);
    if (success) {
      setReplyText('');
      setReplyPhotoUrl('');
    }
  };

  return (
    <Box
      mt={4}
      pl={{ base: 2, md: 4 }}
      borderLeft="2px solid"
      borderColor={borderColor}
    >
      <FormControl>
        <HStack align="start" spacing={{ base: 2, md: 3 }}>
          <Avatar 
            size={{ base: "sm", md: "md" }} 
            name={user?.displayName || 'Guest'} 
            bg="ancient.terracotta"
            color="white"
          />
          <VStack align="start" width="full" spacing={2}>
            <Input
              placeholder="Your reply here..."
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              width="full"
              variant="carved"
              size={{ base: "sm", md: "md" }}
              _placeholder={{ color: 'ancient.stone', opacity: 0.7 }}
            />
            <CommentImageUpload 
              onUploadComplete={setReplyPhotoUrl}
              siteId={siteId}
              initialUrl={replyPhotoUrl}
            />
          </VStack>
          <Button 
            variant="tablet"
            onClick={handleSubmit}
            size={{ base: "sm", md: "md" }}
            rightIcon={<PaperPlaneTilt weight="duotone" />}
            aria-label="Post reply"
          >
            Reply
          </Button>
        </HStack>
      </FormControl>
    </Box>
  );
};

export default ReplyInput;
